:host {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  --back-btn-position: 10px;
}

.header__actions {
  display: flex;
}

.wrapper {
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;
  }

  .grid-view {
    min-height: 100%;
    align-items: stretch;
  }
}

.scheduler-form {
  position: absolute;
  z-index: 9;
  top: 0;
  left: 0;
  background: var(--white-layout-301-level-0-elevation);
}

gz-web-access-control-scheduler-form {
  --enum-filter-content-max-height: 280px;
}
